export const flattenObject = (obj) => {
    const toReturn = {};

    Object.keys(obj).forEach((key) => {
        if ((typeof obj[key]) === 'object' && obj[key] !== null) {
            const flatObject = flattenObject(obj[key]);
            Object.keys(flatObject).forEach((key2) => {
                toReturn[`${key}.${key2}`] = flatObject[key2];
            });
        } else {
            toReturn[key] = obj[key];
        }
    });

    return toReturn;
};

export const unFlattenObject = obj =>
    Object.keys(obj).reduce((res, key) => {
        key.split('.').reduce(
            // eslint-disable-next-line no-return-assign
            (acc, name, index, keys) =>
            // eslint-disable-next-line no-restricted-globals,no-nested-ternary,brace-style
                acc[name] || (acc[name] = isNaN(Number(keys[index + 1]))
                    ? keys.length - 1 === index
                        ? obj[key]
                        : {}
                    : []), res
        );
        return res;
    }, {});

